import { render } from "./BrandValues.vue?vue&type=template&id=31478f82&scoped=true"
import script from "./BrandValues.vue?vue&type=script&lang=js"
export * from "./BrandValues.vue?vue&type=script&lang=js"

import "./BrandValues.vue?vue&type=style&index=0&id=31478f82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31478f82"]])

export default __exports__